import { recoilPersist } from "recoil-persist";

import { CustomerSearchRequest } from "api/request/CustomerSearchRequest";
import { InquirySearchRequest } from "api/request/InquirySearchRequest";
import { LogSearchRequest } from "api/request/LogSearchRequest";
import { NoticeSearchRequest } from "api/request/NoticeSearchRequest";
import { UserSearchRequest } from "api/request/UserSearchRequest";
import { atom } from "recoil";
import { ROLE_TYPE, YN_TYPE } from "types/enumType";
import { encryptString } from "util/encryptUtil";

type UserInfo = {
  customerId: string;
  customerName: string;
  insolationYn: YN_TYPE | string;
  account: string,
  role: string;
  userId: string;
  name: string;
  isAuthenticated: boolean;
}

export type HistorySearchInfo = {
  location: string;
  search: LogSearchRequest | UserSearchRequest | CustomerSearchRequest | NoticeSearchRequest | InquirySearchRequest | null;
}

type UpdatedCustomer = {
  isUpdateCustomer: boolean
}

export const userInfoPersist = recoilPersist({
  key: 'userInfo',
  storage: sessionStorage,
  converter: JSON
})

export const userInfoState = atom<UserInfo>({
  key: 'userInfoState',
  default: {
    customerId: '',
    customerName: '',
    insolationYn: '',
    account: '',
    name: '',
    userId: encryptString(''),
    role: encryptString(ROLE_TYPE.USER),
    isAuthenticated: false,
  },
  effects_UNSTABLE: [userInfoPersist.persistAtom]
})

export const searchInfoState = atom<HistorySearchInfo>({
  key: 'historySearchState',
  default: {
    location: '',
    search: null
  }
})

export const updatedCustomer = atom<UpdatedCustomer>({
  key: 'updatedCustomer',
  default: {
    isUpdateCustomer: false
  }
})